var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdo-view box"},[(_vm.url)?_c('LectureVideo',{attrs:{"url":_vm.url}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }